<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Kalibrasi</h5>
            </template>

            <b-row class="mb-3">
                <b-col cols="12">
                    <FilterKalibrasi
                        :filters="filters"
                        :IS_HAVE_PERMISSION_DOWNLOAD_EXCEL="IS_HAVE_PERMISSION_DOWNLOAD_EXCEL"
                        :IS_HAVE_PERMISSION_ADD_CALIBRATION="IS_HAVE_PERMISSION_ADD_CALIBRATION"
                        :VALIDATE_CABANG="VALIDATE_CABANG"
                        :isBusy="isBusy"
                        :optionsCabang="optionsCabang"
                        :optionsSojikyo="addAllOption(optionsSojikyo)"
                        :optionsSojikyoFirstNumber="addAllOption(optionsSojikyoFirstNumber)"
                        :optionsSojikyoDigitBehindComma="addAllOption(optionsSojikyoDigitBehindComma)"
                        :optionsPocket="addAllOption(optionsPocket)"
                        :optionsBatuUji="addAllOption(optionsBatuUji)"
                        :optionsAirUji="addAllOption(optionsAirUji)"
                        @onSearch="onSearch"
                        @onReset="onReset"
                        @confirmDownloadExcel="confirmDownloadExcel"
                        @onShowModalAdd="onShowModalAdd"
                        @filterChanged="filterChanged"
                    />
                </b-col>
                <b-col cols="12 mt-3">
                    <b-table bordered hover show-empty 
                        :busy="isBusy" 
                        :items="data"
                        :no-local-sorting="false" 
                        :fields="fields"
                        responsive
                        class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data kalibrasi.
                        </template>
                        <template v-slot:cell(tanggal)="row">
                            <p class="mb-0">{{$helper.changeDateFormat(row.item.createdAt)}}</p>
                        </template>
                        <template v-slot:cell(sojikyo)="row">
                            <div>
                                <p class="mb-1">Angka Pertama: {{ getNameById('optionsSojikyoFirstNumber', row.item.sojikyoNumber) }}</p>
                                <p class="mb-1">Digit Koma: {{ getNameById('optionsSojikyoDigitBehindComma', row.item.sojikyoDigit) }}</p>
                                <div class="d-flex flex-wrap" style="gap: 4px;">
                                    <p class="mb-0">Hasil Timbang: </p>
                                    <div>
                                        <span class="status-box-md status-box-success" v-if="row.item.matchSojikyo == 1">Sesuai</span>
                                        <span class="status-box-md status-box-warning" v-else-if="row.item.matchSojikyo == 5">Rusak</span>
                                        <span class="status-box-md status-box-danger" v-else>Tidak Sesuai</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-slot:cell(pocket)="row">
                            <span class="status-box-md status-box-success" v-if="row.item.matchPocket == 1">Sesuai</span>
                            <span class="status-box-md status-box-warning" v-else-if="row.item.matchPocket == 5">Rusak</span>
                            <span class="status-box-md status-box-danger" v-else>Tidak Sesuai</span>
                        </template>
                        <template v-slot:cell(batuUji)="row">
                            <span class="status-box-md status-box-success" v-if="row.item.matchBatuUji == 3">Sudah Dibersihkan</span>
                            <span class="status-box-md status-box-warning" v-else-if="row.item.matchBatuUji == 5">Rusak</span>
                            <span class="status-box-md status-box-danger" v-else>Belum Dibersihkan</span>
                        </template>
                        <template v-slot:cell(airUji)="row">
                            <template v-if="row.item.testWater">
                                <p class="mb-0">{{ getNameById('optionsAirUji', row.item.testWater) }}</p>
                            </template>
                        </template>
                        <template v-slot:cell(action)="row">
                            <template v-if="row.item.paths.length > 0">
                                <ModalFoto isButton :photos="getPathPhoto(row.item.paths)" />
                            </template>
                            <template v-else>
                                <span>Tidak ada foto</span>
                            </template>
                        </template>
                    </b-table>
                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="show" @change="onLimitChange" :options="optionsLimit">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewText }}</span>
                        </b-input-group>
                        <b-pagination class="mb-0"
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                        ></b-pagination>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-modal id="modal-add-calibration" title="Tambah Kalibrasi" size="lg" no-close-on-esc no-close-on-backdrop>
            <b-row>
                <b-col
                    cols="12"
                >
                    <b-list-group>
                        <b-list-group-item v-for="item in sojikyoForms" :key="item.key">
                            <b-form-group :label="item.label">
                                <b-form-select
                                    v-model="forms[item.model]"
                                    :id="`form-${item.key}`"
                                    :name="`form-${item.key}`"
                                    value-field="id"
                                    text-field="name"
                                    :options="getOptionKey(item.options)"
                                >
                                <template #first>
                                    <b-form-select-option :value="null" disabled>
                                    -- Please select an option --
                                    </b-form-select-option>
                                </template>
                                </b-form-select>
                            </b-form-group>

                            <FotoPendukungNonBaseFile
                                :key="fotoKey"
                                class="mt-2"
                                :fotoPendukung="item.foto"
                                :length="1"
                                :minLength="1"
                                :lat="lat"
                                :long="long"
                                :isNotShowCam="true"
                                :isNotRemove="true"
                                @onChange="onChangeFoto"
                                @showModalPreview="openModalPreview"
                            />
                        </b-list-group-item>
                        <StateInputHandler
                            :isLoading="stateCheckAirUji.isLoading"
                            :error="stateCheckAirUji.error"
                            errorMessage="Gagal memuat air uji."
                            @retry="getDateAirUji"
                            fullWidth
                            class="mb-3"
                        >
                            <b-list-group-item v-if="isDateAirUji">
                                <b-form-group label="Apakah sudah mengganti air uji?" >
                                    <b-form-select
                                        v-model="forms.airUji"
                                        id="formAirUji"
                                        name="formAirUji"
                                        value-field="id"
                                        text-field="name"
                                        :options="optionsAirUji"
                                    >
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-form-group>

                                <FotoPendukungNonBaseFile
                                    :key="fotoKey"
                                    class="mt-2"
                                    :fotoPendukung="fotoAirUji"
                                    :length="1"
                                    :minLength="1"
                                    :lat="lat"
                                    :long="long"
                                    :isNotShowCam="true"
                                    :isNotRemove="true"
                                    @onChange="onChangeFotoAirUji"
                                    @showModalPreview="openModalPreviewAirUji"
                                />
                            </b-list-group-item>
                        </StateInputHandler>
                    </b-list-group>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="submitButton" @click="onConfirmAddKalibrasi">
                    Submit
                </b-button>
            </template>
        </b-modal>
        <ModalPreview :fotoPreview="activeFotoPreview" show="true" />
        <ModalConfirm id="modal-confirm-add-calibration" title="Confirm Tambah Kalibrasi" :isSubmitting="isAddCalibration"
            desc="Apakah anda yakin untuk tambah kalibrasi ini ?" @submit="onSubmitAddKalibrasi" />
        <ModalConfirm id="modal-confirm-excel" title="Konfirmasi Download Excel" :isSubmitting="isLoadingExcel" desc="Apakah Anda yakin ingin mendownload kalibrasi dalam format Excel?" @submit="openModalDownloadExcel" />
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="show-btn-download">
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import CONSTANTS from '@/constants'
import ModalFoto from '@/components/modals/ModalFoto'
import FotoPendukungNonBaseFile from '@/components/webcam/FotoPendukungNonBaseFile'
import ModalPreview from '@/components/webcam/ModalPreview'
import FilterKalibrasi from '@/components/gadai/kalibrasi/FilterKalibrasi'
import StateInputHandler from '@/components/common/StateInputHandler'

export default {
    name: 'kalibrasi',
    components: {
        ModalFoto,
        FotoPendukungNonBaseFile,
        ModalPreview,
        FilterKalibrasi,
        StateInputHandler,
    },
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            filters: {
                cabang: null,
                sojikyo: '',
                sojikyoFirstNumber: '',
                sojikyoDigitBehindComma: '',
                pocket: '',
                batuUji: '',
                airUji: '',
                date: null,
            },
            optionsCabang: [],
            optionsSojikyo: [],
            optionsPocket: [],
            optionsBatuUji: [],
            optionsAirUji: [],
            optionsSojikyoFirstNumber: [],
            optionsSojikyoDigitBehindComma: [],
            fields: [
                { key: "cabangName", label: "Cabang" },
                { key: "tanggal", label: "Tanggal", thClass: 'min-width-125', tdClass: 'min-width-125' },
                { key: "sojikyo", label: "Sojikyo", thClass: 'text-center min-width-150', tdClass: 'min-width-150' },
                { key: "pocket", label: "Hasil Timbang Pocket", thClass: 'text-center', tdClass: 'text-center' },
                { key: "batuUji", label: "Kondisi Batu Uji", thClass: 'text-center', tdClass: 'text-center' },
                { key: "airUji", label: "Air Uji", thClass: 'text-center', tdClass: 'text-center' },
                { key: "action", label: "Aksi", thClass: 'text-center min-width-125', tdClass: 'text-center min-width-125' },
            ],
            data: [],
            currentPage: 1,
            show: 10,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            totalViewText: "",
            optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
            forms: {
                sojikyo: null,
                sojikyoFirstNumber: null,
                sojikyoDigitBehindComma: null,
                pocket: null,
                batuUji: null,
                airUji: null,
            },
            activeFotoPreviewIndex: null,
            activeFotoPreview: "",
            lat: 0,
            long: 0,
            isMobile: false,
            isAddCalibration: false,
            filePathDownload: '',
            isLoadingExcel: false,
            isDateAirUji: false,
            stateCheckAirUji: {
                isLoading: false,
                error: null,
            },
            fotoPendukungUrlAddKalibrasi: [],
            sojikyoForms: [
                {
                    key: 'sojikyoFirstNumber',
                    label: 'Angka berapa yang muncul pertama kali ketika menyalakan timbangan Sojikyo?',
                    model: 'sojikyoFirstNumber',
                    options: 'optionsSojikyoFirstNumber',
                    foto: {
                        index: 0,
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                        urlFotoBarangPendukung: null,
                        url: null
                    }
                },
                {
                    key: 'sojikyoDigitBehindComma',
                    label: 'Berapa digit angka dibelakang koma?',
                    model: 'sojikyoDigitBehindComma',
                    options: 'optionsSojikyoDigitBehindComma',
                    foto: {
                        index: 1,
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                        urlFotoBarangPendukung: null,
                        url: null
                    }
                },
                {
                    key: 'sojikyo',
                    label: 'Saat anda menimbang test beban 500 gram pada timbangan Sojikyo, bagaimana hasilnya?',
                    model: 'sojikyo',
                    options: 'optionsSojikyo',
                    foto: {
                        index: 2,
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                        urlFotoBarangPendukung: null,
                        url: null
                    }
                },
                {
                    key: 'pocket',
                    label: 'Saat anda menimbang test beban 500 gram pada timbangan Pocket, bagaimana hasilnya?',
                    model: 'pocket',
                    options: 'optionsPocket',
                    foto: {
                        index: 3,
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                        urlFotoBarangPendukung: null,
                        url: null
                    }
                },
                {
                    key: 'batuUji',
                    label: 'Kondisi Batu Uji',
                    model: 'batuUji',
                    options: 'optionsBatuUji',
                    foto: {
                        index: 4,
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                        urlFotoBarangPendukung: null,
                        url: null
                    }
                },
            ],
            fotoAirUji: {
                index: 5,
                fotoBarangPendukung: null,
                fotoBarangPendukungBase64: null,
                activeFotoPendukungBase64: null,
                urlFotoBarangPendukung: null,
                url: null
            },
            fotoKey: 0,
        }
    },
    computed: {
        IS_HAVE_PERMISSION_ADD_CALIBRATION() {
            return this.$helper.hasPermissionMenuChildren('ACD');
        },
        IS_HAVE_PERMISSION_DOWNLOAD_EXCEL() {
            return this.$helper.hasPermissionMenuChildren('TEK');
        },
        VALIDATE_CABANG() {
            return this.optionsCabang.length > 2;
        },
    },
    methods: {
        async init() {
            this.initStatus = 0
            try {
                this.getCabang()
                await this.getOptions()
                await this.getKalibrasi()
                this.initStatus = 1
            } catch (error) {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            }

            navigator.geolocation.getCurrentPosition(
                position => {
                    this.lat = position.coords.latitude
                    this.long = position.coords.longitude
                },
                error => {
                    console.log(error.message);
                },
            )
        },
        getKalibrasi(page = 1) {
            this.isBusy = true
            this.data = []
            this.currentPage = isNaN(page) ? 1 : page
            const params = this.buildQueryParams()
            
            return this.$axios.get("calibration/get-calibration", {
                params,
            }).then(res => {

                this.data = res.data.content
                this.totalRows = res.data.totalElements

                let pg = this.currentPage - 1

                let prev = pg * this.show + 1
                let limit = pg * this.show + this.show
                if (limit > this.totalRows) limit = this.totalRows

                this.totalViewText = "Menampilkan "+ prev + " - " + limit + " dari " + this.totalRows + " entri"
            }).catch(error => {
                this.$helper.parseError(this, error)
                throw error
            })
            .finally(() => {
                this.isBusy = false
            })
        },
        getCabang() {
            const getCabang = localStorage.getItem("cabang")
            const cabang = JSON.parse(getCabang);

            const mappingName = cabang.map(item => ({
                ...item,
                name: item.name.replace(/^\(\d+\)\s*/, "")
            }));

            this.optionsCabang = [
                { id: null, name: "Semua Cabang" },
                ...mappingName
            ]
        },
        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getKalibrasi();
        },
        onPageChange(newPage) {
            this.getKalibrasi(newPage);
        },
        onSearch() {
            this.getKalibrasi();
        },
        onReset() {
            this.filters = {
                sojikyo: '',
                sojikyoFirstNumber: '',
                sojikyoDigitBehindComma: '',
                pocket: '',
                batuUji: '',
                airUji: '',
                date: null,
                cabang: null,
            }
            this.getKalibrasi();
        },
        onConfirmAddKalibrasi() {
            this.$bvModal.show("modal-confirm-add-calibration")
        },
        async onSubmitAddKalibrasi() {
            if (this.forms.sojikyoFirstNumber !== 0 && this.$helper.isNullOrEmpty(this.forms.sojikyoFirstNumber)) {
                this.$helper.toastErr(this, "Sojikyo angka muncul pertama tidak boleh kosong")
                return
            }

            if (this.forms.sojikyoDigitBehindComma !== 0 && this.$helper.isNullOrEmpty(this.forms.sojikyoDigitBehindComma)) {
                this.$helper.toastErr(this, "Sojikyo angka dibelakang koma tidak boleh kosong")
                return
            }

            if (this.$helper.isNullOrEmpty(this.forms.sojikyo)) {
                this.$helper.toastErr(this, "Hasil timbang sojikyo tidak boleh kosong")
                return
            }

            if (this.$helper.isNullOrEmpty(this.forms.pocket)) {
                this.$helper.toastErr(this, "Hasil timbang pocket tidak boleh kosong")
                return
            }

            if (this.$helper.isNullOrEmpty(this.forms.batuUji)) {
                this.$helper.toastErr(this, "Kondisi batu uji tidak boleh kosong")
                return
            }

            if (this.isDateAirUji && this.$helper.isNullOrEmpty(this.forms.airUji)) {
                this.$helper.toastErr(this, "Harap pilih apakah sudah mengganti air uji atau belum.")
                return
            }

            if (!this.validatePhotos()) return;

            this.isAddCalibration = true;
            const cabangId = this.$helper.getCabangId();

            const photoKeys = [
                ...this.sojikyoForms
                    .map(item => item.foto.url)
                    .filter(Boolean),

                ...(this.fotoAirUji.url ? [this.fotoAirUji.url] : [])
            ]

            const payload = {
                cabangId: Number(cabangId),
                sojikyoFirstNumber: this.forms.sojikyoFirstNumber,
                sojikyoDigitBehindComma: this.forms.sojikyoDigitBehindComma,
                isMatchSojikyo: this.forms.sojikyo,
                isMatchPocket: this.forms.pocket,
                isMatchBatuUji: this.forms.batuUji,
                hasTestWaterHasBeenReplaced: this.forms.airUji,
                photoKeys: photoKeys,
            }

            this.$axios.post('calibration/add-calibration', payload)
                .then(response => {
                    this.getKalibrasi();
                    this.forms = {
                        sojikyo: null,
                        sojikyoFirstNumber: null,
                        sojikyoDigitBehindComma: null,
                        pocket: null,
                        batuUji: null,
                        airUji: null,
                    }
                    this.resetFotoForms()
                    this.$helper.toastSucc(this, response.data.name)   
                    this.$bvModal.hide("modal-confirm-add-calibration")
                    this.$bvModal.hide("modal-add-calibration")
                }).catch(error => {
                    this.$helper.parseError(this, error)
                }).finally(() => {
                    this.isAddCalibration = false;
                })
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 576;
        },
        onShowModalAdd() {
            this.getDateAirUji()
            this.$bvModal.show("modal-add-calibration")
        },
        openModalPreview(index){
            const foto = this.sojikyoForms[index].foto
            if (!foto.url) return

            this.activeFotoPreview = foto.url
            this.$bvModal.show("modal-preview-foto")
        },
        openModalPreviewAirUji() {
            if (!this.fotoAirUji.url) return

            this.activeFotoPreview = this.fotoAirUji.url
            this.$bvModal.show("modal-preview-foto")
        },
        getCabangName() {
            const cabangId = this.$helper.getCabangId();
            const foundCabang = this.optionsCabang.find(item => item.id == cabangId);

            const nameCabang = foundCabang ? foundCabang.name : '';
            return nameCabang
        },
        getPathPhoto(paths) {
            const mappingPaths = paths.map((item) => `${this.$baseFilePathAws}${item.path.slice(1)}`)
            return mappingPaths
        },
        confirmDownloadExcel() {
            this.filePathDownload = '';
            this.$bvModal.show("modal-confirm-excel")
        },
        openModalDownloadExcel() {
            const isValidDate = this.validateDateEmpty();
            if (!isValidDate) {
                this.$helper.toastErr(this, 'Tanggal tidak boleh kosong');
                return;
            }

            this.isLoadingExcel = true;
            const params = this.buildQueryParams();
            delete params.page
            delete params.size

            this.$axios.get("calibration/get-calibration-excel", {
                params,
            }).then(res => {
                this.filePathDownload = res.data.path
                this.$bvModal.show("modal-download-excel")
                this.$bvModal.hide("modal-confirm-excel")
            }).catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadingExcel = false;
            })
        },
        validateDateEmpty() {
            if (!this.filters.date) {
                return false;
            }
            return true;
        },
        buildQueryParams() {
            const params = {
                page: this.currentPage - 1,
                size: this.perPage,
            }

            if (!this.$helper.isNullOrEmpty(this.filters.cabang)) {
                params.cabangName = this.filters.cabang.name;
            }

            if (this.filters.cabang && this.filters.cabang.id === null) {
                delete params.cabangName
            }

            if (!this.$helper.isNullOrEmpty(this.filters.date)) {
                params.startDate = this.filters.date;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.date)) {
                params.endDate = this.filters.date;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.sojikyo)) {
                params.isMatchSojikyo = this.filters.sojikyo;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.pocket)) {
                params.isMatchPocket = this.filters.pocket;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.batuUji)) {
                params.isMatchBatuUji = this.filters.batuUji;
            }

            if (!this.$helper.isNullOrEmpty(this.filters.airUji)) {
                params.testWater = this.filters.airUji;
            }
            
            if (this.filters.sojikyoFirstNumber === 0 || !this.$helper.isNullOrEmpty(this.filters.sojikyoFirstNumber)) {
                params.sojikyoNumber = this.filters.sojikyoFirstNumber;
            }

            if (this.filters.sojikyoDigitBehindComma === 0 || !this.$helper.isNullOrEmpty(this.filters.sojikyoDigitBehindComma)) {
                params.sojikyoDigit = this.filters.sojikyoDigitBehindComma;
            }

            return params
        },
        filterChanged(value) {
            this.filters = value;
        },
        addAllOption(options) {
            return [{ id: '', name: 'Semua' }, ...options]
        },
        getOptions() {
            return this.$axios.get('calibration/get-all-option').then(response => {
                const data = response.data;
                this.optionsSojikyoFirstNumber = data.sojikyoFirstNumber;
                this.optionsSojikyoDigitBehindComma = data.sojikyoBehindComma;
                this.optionsSojikyo = data.sojikyo;
                this.optionsPocket = data.pocket;
                this.optionsBatuUji = data.batuUji;
                this.optionsAirUji = data.testWaterReplaced;
            }).catch(error => {
                throw error
            })
        },
        getOptionKey(key) {
            return this[key] || []
        },
        getNameById(listName, id) {
            const list = this[listName]
            if (!Array.isArray(list)) return null

            const found = list.find(item => item.id === id)
            return found ? found.name : null
        },
        getDateAirUji() {
            this.stateCheckAirUji.isLoading = true;
            this.stateCheckAirUji.error = null;
            this.$axios.get('calibration/check-air-uji').then(response => {
                const data = response.data;
                this.isDateAirUji = data.wajibAirUji == '1';
            }).catch(error => {
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateCheckAirUji.error = errorMessage;
            }).finally(() => {
                this.stateCheckAirUji.isLoading = false;
            })
        },
        async onChangeFoto(file, index) {
            const fileUpload = this.$helper.createSafeFileCopy(file)
            const path = 'calibration/create-presigned-url_calibrations'
            const params = { cabangName: this.getCabangName() }

            this.$store.dispatch("loading/show")
            const response = await this.$helper.uploadPresigned({
                vue: this,
                path,
                params,
                fileUpload
            })
            this.$store.dispatch("loading/hide")

            if (!response.success) {
                this.$set(this.sojikyoForms[index], 'foto', {
                    index: index,
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                    urlFotoBarangPendukung: null,
                    url: null
                })
                this.$helper.toastErr(this, "Gagal upload foto. Silakan coba lagi.")
                return
            }

            this.$set(
                this.sojikyoForms[index].foto,
                'url',
                response.publicUrl
            )
        },
        async onChangeFotoAirUji(file) {
            const fileUpload = this.$helper.createSafeFileCopy(file)
            const path = 'calibration/create-presigned-url_calibrations'
            const params = { cabangName: this.getCabangName() }

            this.$store.dispatch("loading/show")
            const response = await this.$helper.uploadPresigned({
                vue: this,
                path,
                params,
                fileUpload
            })
            this.$store.dispatch("loading/hide")

            if (!response.success) {
                this.fotoAirUji = {
                    index: 5,
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                    urlFotoBarangPendukung: null,
                    url: null
                }
                this.$helper.toastErr(this, "Gagal upload foto air uji.")
                return
            }

            this.fotoAirUji = {
                ...this.fotoAirUji,
                url: response.publicUrl
            }

        },
        validatePhotos() {
            const list = this.sojikyoForms || []
            const invalid = list.find(item => !item.foto.url)

            if (invalid) {
                this.$helper.toastErr(
                    this,
                    `Foto untuk "${invalid.label}" wajib diunggah`
                )
                return false
            }

            if (this.isDateAirUji && !this.fotoAirUji.url) {
                this.$helper.toastErr(
                    this,
                    "Harap unggah foto Air Uji terlebih dahulu"
                )
                return false
            }

            return true
        },
        resetFotoForms() {
            this.sojikyoForms = this.sojikyoForms.map(item => {
                return {
                    ...item,
                    foto: {
                        index: item.foto.index,
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                        urlFotoBarangPendukung: null,
                        url: null
                    }
                };
            });

            this.fotoAirUji = {
                index: 5,
                fotoBarangPendukung: null,
                fotoBarangPendukungBase64: null,
                activeFotoPendukungBase64: null,
                urlFotoBarangPendukung: null,
                url: null
            }

            this.fotoKey++
        }
    },
    created() {
        this.init();
    },
    mounted() {
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.handleResize);
    }
}
</script>